import ListMetaRow from "./ListMetaRow";
import { COLORS, SHADOWS, GRADIENTS, FONT_SIZES } from "../../theme";

export default function Headline({ date, tablet, gradients, showIcons, displayDates, image, title }) {
    return (
        <>
            <label className="headline" htmlFor="listImage1" style={{ width: "100%", boxSizing: "border-box", display: "flex", justifyContent: "space-between", boxShadow: SHADOWS.card, padding: "2rem", borderRadius: "1.5rem", backgroundColor: COLORS.cardBg, margin: "1rem 0" }}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", width: "64%" }}>
                    <p style={{ fontSize: FONT_SIZES.listTitle, margin: 0, zIndex: 20, color: COLORS.textPrimary, fontWeight: 500 }}>{title}</p>
                    <ListMetaRow showIcons={showIcons} displayDates={displayDates} date={date} wrapperStyle={{ color: COLORS.textMuted }} />
                </div>
                <div className="tile-image" style={{ position: 'relative', display: "flex", alignItems: "center", width: "32%", marginLeft: "4%" }}>
                    <img src={image ? image : 'plus.png'} style={{ width: "100%", objectFit: "cover", borderRadius: "12px", height: tablet ? "24rem" : "14rem" }} alt="" />
                    <div className='gradient' style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: GRADIENTS.imageOverlay, zIndex: 2, opacity: gradients ? "90%" : "0", borderRadius: "12px" }}>&nbsp;</div>
                </div>
            </label>
        </>
    )
}